import { useViewerStore } from "../store/store";

/** Active designs finalized on/after this date use design-centered sun rays (ODR-1784). */
export const DESIGN_CENTERED_SUN_CUTOFF = new Date("2026-07-17");

export type SunPositionVersion = "legacy" | "updated";

export function shouldUseDesignCenteredSunPosition(
    designFinalizationTimestamp?: string | null,
): boolean {
    if (!designFinalizationTimestamp) return true;
    const finalizedAt = new Date(designFinalizationTimestamp);
    if (Number.isNaN(finalizedAt.getTime())) return true;
    return finalizedAt >= DESIGN_CENTERED_SUN_CUTOFF;
}

export function isPreCutoffSunPositionDesign(
    designFinalizationTimestamp?: string | null,
): boolean {
    if (!designFinalizationTimestamp) return false;
    const finalizedAt = new Date(designFinalizationTimestamp);
    if (Number.isNaN(finalizedAt.getTime())) return false;
    return finalizedAt < DESIGN_CENTERED_SUN_CUTOFF;
}

/** True if any design version on the site was finalized before the ODR-1784 cutoff. */
export function hasPreCutoffSunPositionHistory(
    designs?: Array<{ User_Created_Timestamp?: string | null }> | null,
): boolean {
    return !!designs?.some((design) =>
        isPreCutoffSunPositionDesign(design?.User_Created_Timestamp),
    );
}

export function flagToSunPositionVersion(useDesignCentered: boolean): SunPositionVersion {
    return useDesignCentered ? "updated" : "legacy";
}

export function sunPositionVersionToFlag(version: SunPositionVersion): boolean {
    return version === "updated";
}

export function applySunPositionVersionFromDesign(
    design?: { User_Created_Timestamp?: string | null } | null,
): void {
    useViewerStore.setState({
        useDesignCenteredSunPosition: shouldUseDesignCenteredSunPosition(
            design?.User_Created_Timestamp,
        ),
    });
}

/** Saved mapJson key wins over the date cutoff when present. */
export function applySunPositionVersionFromMapJson(
    json?: { sunPositionVersion?: string | null } | null,
): void {
    const version = json?.sunPositionVersion;
    if (version === "legacy") {
        useViewerStore.setState({ useDesignCenteredSunPosition: false });
        return;
    }
    if (version === "updated") {
        useViewerStore.setState({ useDesignCenteredSunPosition: true });
    }
}
